import { CustomFieldEditDrawer } from '../translations-types';

const translations: CustomFieldEditDrawer = {
  createField: 'Create label',
  editField: 'Edit label',
  addCustomField: 'Add customer label',
  areYouSureYouWantToDelete: 'Are you sure you want to delete customer label "{{name}}"?',
  deleteCustomField: 'Delete customer label',
};

export default translations;
